var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStorage = function SvgStorage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 19.771 14.828"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.762 0 1.437 1.438h7.772c.383 0 .722.147 1.022.449.274.275.418.58.442.92H8.608L7.194 1.398l-.029-.029h-5.8v12.808l2.517-9.793h15.89L17.375 13.6c-.12.446-.32.754-.588.94-.272.188-.639.287-1.106.287H1.464c-.378 0-.716-.146-1.017-.447Q0 13.93 0 13.365V1.47Q-.002.896.447.446.9-.002 1.464 0zM4.89 5.747l-.019.076-1.85 7.518-.032.124H16l.019-.076L17.87 5.87l.03-.124z"
  })));
};
export default SvgStorage;